export default function WhatWeRepair() {
  const items = [
    "Crémone bloquée ou cassée : remplacement du mécanisme de verrouillage complet",
    "Poignée qui tourne dans le vide ou qui est bloquée : changement de la poignée et de l'axe",
    "Fermeture oscillo-battant déréglée : recalage des ciseaux et des galets de compression",
    "Fenêtre qui s'affaisse ou qui frotte : remplacement des gonds ou paumelles usées",
    "Fenêtre qui ferme mal ou qui laisse passer l'air : réglage des joints et de la compression",
    "Joint de vitrage abîmé : conseil et remplacement pour retrouver l'étanchéité",
    "Anti-fausse manœuvre défectueux : remplacement pour rétablir la double ouverture",
    "Régulation de la hauteur du vantail : réglage précis pour un fonctionnement fluide",
  ];

  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-4 md:mb-6">
            Ce que nous réparons sur une fenêtre PVC
          </h2>
          <p className="text-base md:text-lg text-plum-dark leading-relaxed mb-6 md:mb-8">
            Quelle que soit la panne sur votre fenêtre PVC, notre technicien arrive avec un diagnostic portable et une gamme de pièces adaptées. Voici les interventions les plus fréquentes que nous réalisons chez vous en une seule visite dans le Bas-Rhin.
          </p>
          <p className="text-base md:text-lg text-plum-dark leading-relaxed mb-6 md:mb-8">
            Nous ne remplaçons pas ce qui est réparable. Si le mécanisme peut être réglé, nettoyé ou resserré, nous le faisons d'abord. Si la pièce est trop usée, nous la changeons avec une pièce neuve compatible. Chaque intervention est testée sur place avant notre départ : fermeture, compression, étanchéité à l'air et fonctionnement de la poignée.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
            {items.map((item) => (
              <div key={item} className="flex items-start gap-3 bg-white rounded-2xl p-4 md:p-5 border border-rose-100">
                <div className="w-6 h-6 rounded-full bg-coral/10 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-check-line text-coral text-sm" />
                </div>
                <p className="text-sm md:text-base text-plum-dark leading-relaxed">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}